<template>
  <svg width="53" height="23" viewBox="0 0 53 23" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="NEW">
    <rect width="53" height="23" rx="11.5" fill="#D11635"/>
    <path d="M13.08 16V7.6H14.472L18.6 13.6V7.6H20.04V16H18.648L14.52 10V16H13.08ZM22.1972 16V7.6H27.8372V8.848H23.6372V11.056H27.4772V12.304H23.6372V14.752H27.8372V16H22.1972ZM31.1372 16L28.9172 7.6H30.4052L32.0012 13.84L33.8372 7.6H35.0372L36.9812 13.84L38.5652 7.6H39.9572L37.7372 16H36.2972L34.3892 9.76L32.5772 16H31.1372Z" fill="white"/>
  </svg>
</template>
